import type { ReactNode } from "react";
import React, { useState } from "react";
import { ChartAlertButtonTooltip } from "./style";

interface ChartAlertButtonTooltipWrapperProps {
  overlay: ReactNode; // Change to ReactNode
  children: (params: { isTooltipVisible: boolean }) => ReactNode;
}

const ChartAlertButtonTooltipWrapper = ({
  overlay,
  children
}: ChartAlertButtonTooltipWrapperProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  return (
    <ChartAlertButtonTooltip
      onVisibleChange={(visible: boolean) => {
        setIsVisible(visible);
      }}
      overlay={overlay}
    >
      {children({ isTooltipVisible: isVisible })}
    </ChartAlertButtonTooltip>
  );
};

export default ChartAlertButtonTooltipWrapper;
